import type { FeatureFlagProfile } from './feature-flag-profile';

export const isFeatureFlagProfile = (
    profile: unknown,
): profile is FeatureFlagProfile => {
    if (!profile || typeof profile !== 'object') {
        return false;
    }

    const candidate = profile as Partial<FeatureFlagProfile>;

    return (
        typeof candidate.PrimaryKey === 'string' &&
        typeof candidate.Name === 'string' &&
        typeof candidate.CustomAttributes === 'object' &&
        candidate.CustomAttributes !== null &&
        typeof candidate.PrivateCustomAttributes === 'object' &&
        candidate.PrivateCustomAttributes !== null
    );
};
